import { render, staticRenderFns } from "./ElementosPorPaginaComponent.vue?vue&type=template&id=1f1e30b0"
import script from "./ElementosPorPaginaComponent.vue?vue&type=script&lang=js"
export * from "./ElementosPorPaginaComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports